import cn from 'classnames';
import React from 'react';

import { Icon } from '@sravni/react-design-system';
import { Minus, Plus } from '@sravni/react-icons';

import style from './style.module.scss';

interface IProps {
  className?: string;
  onClickZoomIn: (event: React.MouseEvent<HTMLDivElement>) => void;
  onClickZoomOut: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const Index: React.FC<IProps> = (props: IProps) => {
  const { className, onClickZoomIn, onClickZoomOut } = props;

  return (
    <div className={cn(className, style.wrapper)}>
      <div onClick={onClickZoomIn} className={style.icon}>
        <Icon icon={<Plus />} size={24} />
      </div>
      <div onClick={onClickZoomOut} className={style.icon}>
        <Icon icon={<Minus />} size={24} />
      </div>
    </div>
  );
};

export default Index;
